import { PUBLIC_ROUTE } from "src/app/constants/routes.constants";

export const LOGIN_ROUTE ={
    path: 'login',
    get url(): string{
        return `${PUBLIC_ROUTE.url}/${this.path}`
    }
};

export const SIGNUP_ROUTE = {
    path: 'signup',
    get url(): string{
        return `${PUBLIC_ROUTE.url}/${this.path}`
    }
};

export const PROFILE_SETUP_ROUTE = {
    path: 'profile-setup',
    get url(): string{
        return  `${PUBLIC_ROUTE.url}/${this.path}`
    }
};

export const RESET_ROUTE = {
    path: 'reset-password/:token',
    param: 'token',
    get url(): string{
        return `${PUBLIC_ROUTE.url}/${this.path}`
    }
};

export const FORGOT_ROUTE = {
    path: 'forgot-password',
    get url(): string{
        return `${PUBLIC_ROUTE.url}/${this.path}`
    }
};
